import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";

import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Content from "../Components/Content";

import Inleiding from "../Chapters/1/Inleiding";

import "./general.scss";
import HetAmazonenwoud from "../Chapters/1/HetAmazonewoud";
import DeDieren from "../Chapters/1/DeDieren";
import HetBoek from "../Chapters/2/HetBoek";
import HetVerhaalVanMascopiro from "../Chapters/2/HetVerhaalVanMascopiro";
import Mayu from "../Chapters/3/Mayu";
import ShipiboConibo from "../Chapters/3/ShipiboConibo";
import MayuII from "../Chapters/3/MayuII";
import MayuIII from "../Chapters/3/MayuIII";
import DeBoskoffer from "../Chapters/3/DeBoskoffer";
import België from "../Chapters/4/België";
import BomenInBelgië from "../Chapters/4/BomenInBelgië";
import WatKunnenWijDoen from "../Chapters/5/WatKunnenWijDoen";
import HetWoudRedden from "../Chapters/5/HetWoudRedden";
import Einde from "../Chapters/5/Einde";
import Start from "../Components/Start";

const history = createBrowserHistory();

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <div className="fitpage">
          <Header />
          <Content>
            <Switch>
              <Route exact path="/" component={Start} />
              <Route path="/1/Inleiding" component={Inleiding} />
            </Switch>
            <Route path="/1/het-amazonewoud" component={HetAmazonenwoud} />
            <Route path="/1/de-dieren" component={DeDieren} />
            <Route path="/2/het-boek" component={HetBoek} />
            <Route
              path="/2/het-verhaal-van-mascopiro"
              component={HetVerhaalVanMascopiro}
            />
            <Route path="/3/mayu" component={Mayu} />
            <Route path="/3/gemeenschappen" component={ShipiboConibo} />
            <Route path="/3/mayu-ii" component={MayuII} />
            <Route path="/3/mayu-iii" component={MayuIII} />
            <Route path="/3/de-boskoffer" component={DeBoskoffer} />
            <Route path="/4/belgie" component={België} />
            <Route path="/4/bomen-in-belgie" component={BomenInBelgië} />
            <Route path="/5/wat-kunnen-wij-doen" component={WatKunnenWijDoen} />
            <Route path="/5/het-woud-redden" component={HetWoudRedden} />
            <Route path="/5/einde" component={Einde} />
          </Content>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default DragDropContext(HTML5Backend)(App);
